import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { games } from '../data/games';
import { useAuth } from '../context/AuthContext';
import { getActiveSubscription } from '../utils/subscriptionStorage';
import './GamePlayer.css';

const GamePlayer: React.FC = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const navigate = useNavigate();
  const { openLoginForGame } = useAuth();
  const [gameUrl, setGameUrl] = useState<string>('');
  const game = games.find((g) => g.id === gameId);

  useEffect(() => {
    if (!game) {
      return;
    }

    if (!getActiveSubscription()) {
      openLoginForGame(game);
      navigate('/');
      return;
    }

    setGameUrl(game.gameUrl || '');
  }, [game, gameId, navigate, openLoginForGame]);

  if (!game) {
    return (
      <div className="game-player-error">
        <h2>Game not found</h2>
        <button onClick={() => navigate('/')}>Go Home</button>
      </div>
    );
  }

  return (
    <div className="game-player">
      <div className="game-player-header">
        <button
          className="close-button"
          onClick={() => navigate('/')}
          aria-label="Close game"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
        <h2 className="game-player-title">{game.title}</h2>
        <div style={{ width: '24px' }}></div>
      </div>
      
      <div className="game-player-content">
        {gameUrl ? (
          <iframe
            src={gameUrl}
            className="game-iframe"
            title={game.title}
            allowFullScreen
            allow="autoplay; fullscreen; gamepad; microphone; camera"
          />
        ) : (
          <div className="game-placeholder">
            <div className="placeholder-icon">🎮</div>
            <h3>Game Loading...</h3>
            <p>Game URL will be configured soon</p>
            <button
              className="back-to-games-button"
              onClick={() => navigate('/')}
            >
              Back to Games
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GamePlayer;

